const cartDiscountCodesUpdateQuery = () => {
  return `
mutation cartDiscountCodesUpdate($cartId: ID!, $discountCodes: [String!]) {
    cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {
      cart {
        discountCodes {
          applicable
          code
        }
        lines(first: 100) {
          nodes {
            discountAllocations {
              discountApplication {
                allocationMethod
                targetSelection
                targetType
              }
              discountedAmount {
                amount
                currencyCode
              }
            }
          }
        }
      }
      userErrors {
        field
        message
      }
      warnings {
        code
        message
        target
      }
    }
  }`;
};

export default cartDiscountCodesUpdateQuery;
